/*
 * Copyright (c) 2023 Irian Software Development SRL. All Rights Reserved.
 * This software is the proprietary information of Irian Software Development SRL.
 * Use is subject to license and non-disclosure terms
 */
import { DeptMenu, PrimengMenuItem, ProviderMenuItem } from './menu-item.interface';
import * as _ from 'lodash';

export class PrimengMenuHandler {
  primengBrutMenuItems: PrimengMenuItem[] = [];
  primengMenuItems: PrimengMenuItem[] = [];

  constructor(providerMenuItems: Array<ProviderMenuItem>) {
    const splitDeptMenu: DeptMenu[] = this.splitWeight(providerMenuItems);
    this.addItem(splitDeptMenu, this.primengBrutMenuItems);
    this.reindexMenuItems(this.primengBrutMenuItems, this.primengMenuItems);
  }

  addItem(menu: DeptMenu[], ref): void {
    menu = _.cloneDeep(menu);
    menu.map((item) => {
      const item_key = item.dept[0] - 1;

      if (item.dept?.length === 1) {
        delete item.dept;
        ref[item_key] = ref[item_key]
          ? Object.assign(ref[item_key], item)
          : item;
      } else {
        ref[item_key] = ref[item_key] || {};
        ref[item_key].items = ref[item_key].items || [];
        item.dept?.shift();
        this.addItem([item], ref[item_key].items);
      }
      return item;
    });
  }

  splitWeight(menuItems: ProviderMenuItem[]): DeptMenu[] {
    const menu = _.cloneDeep(menuItems);
    return menu.map((item: ProviderMenuItem) => {
      item['dept'] = item.weight?.split('.');
      delete item.weight;
      return <DeptMenu>item;
    });
  }

  getMenu(): Array<PrimengMenuItem> {
    return this.primengMenuItems;
  }

  private reindexMenuItems(menu: PrimengMenuItem[], ref): void {
    menu = _.cloneDeep(menu);
    menu = menu.filter((item) => {
      return item != undefined;
    });

    ref.push(...menu);

    menu.map((item, key) => {
      if (item && item.items && item.items.length) {
        this.reindexMenuItems(item.items, (ref[key].items = []));
      }
    });
  }
}
